/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PackageDto
 */
export interface PackageDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof PackageDto
     */
    'allowedDosingUnits'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PackageDto
     */
    'amount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageDto
     */
    'dose'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageDto
     */
    'drugKind'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageDto
     */
    'ean'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PackageDto
     */
    'form'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PackageDto
     */
    'id'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PackageDto
     */
    'payments'?: Array<PackageDtoPaymentsEnum>;
    /**
     * 
     * @type {string}
     * @memberof PackageDto
     */
    'prescriptionType'?: PackageDtoPrescriptionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof PackageDto
     */
    'productId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PackageDto
     */
    'structuralDosingRequired'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PackageDto
     */
    'suggestedDosingUnit'?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum PackageDtoPaymentsEnum {
    X = 'X',
    B = 'B',
    R = 'R',
    P30 = 'P30',
    P50 = 'P50',
    P100 = 'P100'
}
/**
    * @export
    * @enum {string}
    */
export enum PackageDtoPrescriptionTypeEnum {
    Rp = 'RP',
    Rpw = 'RPW',
    Rps = 'RPS',
    Lz = 'LZ',
    Rplz = 'RPLZ',
    Lzrp = 'LZRP',
    Xlz = 'XLZ',
    Xrplz = 'XRPLZ',
    Rpwlz = 'RPWLZ',
    Rpz = 'RPZ'
}


